"use client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { campaignService } from "@/app/_services/CampaignService";
import LoadingSpinner from "@/app/admin/_common/LoadingSpinner";
import { TriangleAlert as WarningIcon } from "lucide-react";

export default function DeleteDialog({
  open = true,
  campaignId,
  handleClose,
}: {
  open: boolean;
  campaignId: string;
  handleClose: any;
}) {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);

  const handleDeleteCampaign = async () => {
    try {
      setDeleting(true);
      await campaignService.deleteCampaignAsync(campaignId);
      navigate("/admin/marketing/campaigns", { replace: true });
    } catch {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disablePortal
      sx={{
        "& .MuiPaper-root": { boxShadow: "3px 3px 20px #00000010" },
        "& .MuiBackdrop-root": { background: "#00000010" },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ p: 1.5, pl: 1.5, borderBottom: "1px solid #e9e9e9" }}
      >
        <Grid container>
          <WarningIcon style={{ marginRight: "12px" }} color="error" />
          <Typography>
            <b>Delete Campaign</b>
          </Typography>
        </Grid>
      </DialogTitle>
      <Grid container p={2}>
        <Typography>Permanently delete this campaign? This cannot be undone.</Typography>
      </Grid>
      <DialogActions sx={{ borderTop: "1px solid #e9e9e9" }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          disabled={deleting}
          sx={{
            color: "#00000070",
            border: "1px solid #00000050 !important",
            textTransform: "none",
            ":hover": { background: "white" },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteCampaign}
          color={"error"}
          disableElevation
          variant="contained"
          disabled={deleting}
          autoFocus
          sx={{ textTransform: "none" }}
        >
          {deleting ? <LoadingSpinner showText={false} size={30} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
